// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1df3y","clinicsSelect":"TableHeading_clinicsSelect__2zS-G"};